module.exports = __webpack_public_path__ + "img/showbill8.80629f32.jpg";